<template>
  <div class="admin-gdpr">
    <admin-view-header title="Informacja RODO">
      <div class="buttons">
        <protected :with="Permission.CREATE_TEMPLATE">
          <button class="button is-danger is-outlined" @click="resetForm">
            <icon name="fa-trash" />
            <span>Wyczyść</span>
          </button>
        </protected>
        <button class="button is-primary is-outlined" @click="showPreview">
          <icon name="fa-eye" />
          <span>Podgląd</span>
        </button>
        <protected :with="Permission.CREATE_TEMPLATE">
          <button
            class="button is-primary"
            @click="submit"
            :class="{ 'is-loading': submitting }"
            :disabled="submitting"
          >
            <icon name="fa-check" />
            <span>Zapisz</span>
          </button>
        </protected>
      </div>
    </admin-view-header>

    <loader :state="actions.templates">
      <div class="field">
        <span class="label">{{ FIELDS[T.Gdpr.CONTENT] }}</span>
        <editor
          menu
          frame
          v-model="fields[T.Gdpr.CONTENT]"
          placeholder="Treść informacji RODO..."
          bold
          italic
          underline
          strike
          link
          ordered-list
          bullet-list
          history
          hard-break
          blockquote
          line
          :heading="[1, 2, 3]"
          :readonly="!hasPermission(Permission.CREATE_TEMPLATE)"
        />
      </div>

      <template #loading>
        <div
          class="spinner is-3by4 is-grey-lighter is-thick is-large is-centered"
        ></div>
      </template>

      <template #error>
        <div class="grey-message">
          <icon name="fa-times-circle" />
          <p>Dane niedostępne z powodu braku połączenia z serwerem.</p>
        </div>
      </template>
    </loader>
  </div>
</template>

<script>
import AdminViewHeader from "%admin/components/global/AdminViewHeader";

import {
  Protected,
  WithTemplates,
  WithUnsavedChangesConfirmation,
  WithPreview,
  WithReset
} from "%mixins";

import { Icon } from "%helpers";

import Editor from "%admin/components/global/Editor";

import T from "%const/templates";

const FIELDS = {
  [T.Gdpr.CONTENT]: "Informacja RODO"
};

export default {
  name: "admin-gdpr",

  mixins: [
    Protected,

    WithTemplates({
      templates: [T.Gdpr.CONTENT]
    }),

    WithUnsavedChangesConfirmation({
      checkChanges() {
        return (
          this.templatesLoaded() && this.areAnyTemplateChanges(this.fields)
        );
      },

      async onSave() {
        return await this.submit();
      }
    }),

    WithPreview({
      path: "/gdpr"
    }),

    WithReset(function() {
      this.initData();
    })
  ],

  components: {
    Icon,
    AdminViewHeader,
    Editor
  },

  data() {
    return {
      T,
      FIELDS,

      fields: {
        [T.Gdpr.CONTENT]: ""
      },

      submitting: false
    };
  },

  async mounted() {
    await this.requestTemplates();
    this.initData();
  },

  methods: {
    async submit() {
      return await this.updateChangedTemplates(
        this.fields,
        FIELDS,
        () => (this.submitting = true),
        () => (this.submitting = false)
      );
    },

    initData() {
      this.applyTemplates(this.fields);
    }
  }
};
</script>

<style></style>
